import { DataSource } from '../types/enums';

// Helper to format numbers with commas and precision
const formatNumber = (value: number, precision: number): string => {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

// Format polygon count
export const formatPolygonCount = (count: number): string => {
  return `${count} polygon${count !== 1 ? 's' : ''}`;
};

// Format area in hectares
export const formatArea = (area: number | undefined, includeUnit = true): string => {
  if (area === undefined || area === null) return '--';
  const formatted = area.toFixed(2);
  return includeUnit ? `${formatted} ha` : formatted;
};

// Format NEE values
export const formatNEE = (
  neeValue: number | null | undefined,
  unit: 'kgCO2' | 'tCO2' = 'tCO2',
  precision = 2,
  includeUnit = true
): string => {
  if (neeValue === null || neeValue === undefined) return '-';
  const conversionFactor = unit === 'tCO2' ? 1 : 1000;
  const convertedValue = neeValue / conversionFactor;
  const formattedValue = formatNumber(convertedValue, precision);
  return includeUnit ? `${formattedValue} ${unit}` : formattedValue;
};

// Format intensity values
export const formatIntensity = (
  intensityValue: number | null | undefined,
  precision = 2,
  includeUnit = true
): string => {
  if (intensityValue === null || intensityValue === undefined) return '-';
  const formattedValue = formatNumber(intensityValue, precision);
  return includeUnit ? `${formattedValue} tCO2/ha` : formattedValue;
};

// Format year range
export const formatYearRange = (startYear: number, endYear: number): string => {
  return `${startYear} - ${endYear}`;
};

// Format polygon selection count
export const formatSelectionCount = (selected: number, total: number): string => {
  return `${selected} selected of ${total}`;
};

// Format data source license
export const formatLicense = (source: DataSource): string => {
  return source === DataSource.LANDSAT ? 'Public Domain' : 'CC BY 4.0';
};
